export default __webpack_public_path__ + "static/media/Weather5.7bc5aa92.PNG";